import { AfterViewInit, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'info-dialog',
  providers: [],
  styleUrls: ['./info-dialog.scss'],
  standalone: true,
  imports: [
    MatDialogClose,
    MatDialogTitle,
    MatButton,
    MatDialogContent,
    MatDialogActions,
    MatIcon,
    TranslateModule,
  ],
  templateUrl: './info-dialog.html'
})
export class InfoDialogComponent implements AfterViewInit {
    public text = '';
    constructor(
        private _translater: TranslateService,
        private _toaster: MatSnackBar,
        private _changeDetector: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) private _data : any
    ) {
        this.text = this._data.text;
    }

    public ngAfterViewInit() {
    }
}
